import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as Logo } from "../../../asset/imgs/MainBackGround/logo.svg";
import useModuleMenu from "./hooks/useModuleMenu";
import SwitchTheme from "./components/SwitchTheme";
import { useLocation } from "react-router-dom";
function AppLogo({ toggleMenuHandler }) {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width: 767px)");
  const location = useLocation();
  const mainPage = "/dashboard/overview";
  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Button
            href={location.pathname !== mainPage && mainPage}
            sx={{ p: 0, minWidth: "unset" }}
          >
            <Logo className="loogo" />
          </Button>

          <h1
            className="company-title"
            style={{
              color: theme.palette.mode === "dark" ? "#FFF" : "#000",
            }}
          >
            رسام نقش آناهیتا
          </h1>
        </Box>

        {isMobile && <SwitchTheme />}
      </Box>
    </>
  );
}

export default React.memo(AppLogo);
